


















import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import ClearCartTrigger from './ClearCartTrigger.coffee'

export default
  name: 'ClearCartModal'
  props: ['resourceComponent', 'resourceKey']
  components: { Modal, RequestButton }
  mixins: [ClearCartTrigger.trigger(ClearCartTrigger)]

